/**
 * Request helper utility
 * 
 * A simple fetch wrapper that handles JSON responses and errors
 * with timeout support
 */

export default async function request(url, options = {}) {
  // Add timeout to prevent hanging requests
  const timeout = options.timeout || 10000; // 10 seconds default
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeout);

  try {
    const response = await fetch(url, {
      headers: { 
        'Content-Type': 'application/json', 
        ...(options.headers || {}) 
      },
      signal: controller.signal,
      credentials: 'include',
      ...options,
    });

    clearTimeout(timeoutId);

    let data = null;
    try {
      data = await response.json();
    } catch (e) {
      // Non-JSON response
    }

    if (!response.ok) {
      const err = new Error(data?.message || `Request failed: ${response.status}`);
      err.status = response.status;
      err.code = response.status;
      err.data = data;
      throw err;
    }

    return data;
  } catch (error) {
    clearTimeout(timeoutId);
    
    if (error.name === 'AbortError') {
      const timeoutError = new Error(`Request timeout after ${timeout}ms`);
      timeoutError.code = 'TIMEOUT';
      throw timeoutError;
    }
    
    throw error;
  }
}
